module.exports = __webpack_public_path__ + "images/1974079facecbecf63de31717e593002.webp";